module.exports = __webpack_public_path__ + "img/Bingmo goods visual operation management software V1.0.ddfe59fb.jpg";